import React from 'react'
import { useQuery } from "@apollo/client"
import { filter, map, find, isEmpty } from 'lodash'

import { QUERY_SERVICES_DATA } from '../../data/services/graphqlQueries'
import SectionHeader from '../../components/SectionHeader'
import ServiceCard from './ServiceCard'

export default ({globalData, clinic}) => {

  const { loading, error, data } = useQuery(QUERY_SERVICES_DATA, {
    notifyOnNetworkStatusChange: true,
    variables: { clinic: clinic ? clinic.url : '' },
  });

  if (loading) return null

  const services = filter(data.services, (d) => {
    if (clinic) {
      return d.serviceType === 'services' && d.clinic === clinic.url
    }
  
    return d.serviceType === 'services' && !d.clinic
  })

  const eyewear = filter(data.services, (d) => {
    if (clinic) {
      return d.serviceType === 'eyewear' && d.clinic === clinic.url
    }
  
    return d.serviceType === 'eyewear' && !d.clinic
  })

  const patients = filter(data.services, (d) => {
    if (clinic) {
      return d.serviceType === 'patients' && d.clinic === clinic.url
    }
  
    return d.serviceType === 'patients' && !d.clinic
  })

  const pageDescription = find(data.pageDescriptions, (pd) => {
    if (clinic) {
      return pd.clinic === clinic.url
    }
  
    return !pd.clinic
  })

  const compact = true
  const gridStyles = compact ? "grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" : "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"

  return (
    <React.Fragment>
      {
        services.length > 0 &&
        <div className="bg-neutral-100 border-b">
          <div className="max-w-6xl mx-auto px-4 py-16 min-h-64 border-top border-bottom border-gray-700 py-8">
            <SectionHeader subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} title={'Services'} theme="black" />
            <div className={gridStyles}>
              {
                map(services, (s, ndx) => {
                  return (
                    <ServiceCard clinc={clinic} data={s} section="services" theme="dark" key={`service-${ndx}`} compact={true} />
                  )
                })
              }
            </div>
           </div>
        </div>
      }

      {
        eyewear.length > 0 && 
        <div className="border-b">
          <div className="max-w-6xl mx-auto px-4 py-16 min-h-64 py-8">
            <SectionHeader subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} title={'Eyewear'} />
            <div className={gridStyles}>
              {
                map(eyewear, (e, ndx) => {
                  return (
                    <ServiceCard clinc={clinic} data={e} section="eyewear" key={`eyewear-${ndx}`} compact={true} />
                  )
                })
              }
            </div>
          </div>
        </div>
      }
      
      {
        patients.length > 0 &&
        <div className="bg-neutral-100 border-b">
          <div className="max-w-6xl mx-auto px-4 py-16 min-h-64 border-top border-bottom border-gray-700 py-8">
            <SectionHeader subtitle={clinic ? clinic.name : 'Eye Clinics of Seattle'} title={'Patients'} theme="black" />
            <div className={gridStyles}>
              {
                map(patients, (p, ndx) => {
                  return (
                    <ServiceCard clinc={clinic} data={p} section="services" theme="dark" key={`patients-${ndx}`} compact={true} />
                  )
                })
              }
            </div>
           </div>
        </div>
      }
      
    </React.Fragment>
  )

}